module.exports = __webpack_public_path__ + "static/Syberia1-5a3e2b4e1297e520c359ae50a87091a1.png";